import React, { useEffect, useState } from "react";
import { Outlet, useNavigate, useLocation } from "react-router-dom";
import ResponsiveSideBar from "../components/SideBar/ResponsiveSideBar";

const AlumnoRoutes = () => {
  const navigate = useNavigate();
  const userRole = sessionStorage.getItem("userRole");
  const [actualLocation, setActualLocation] = useState(null);
  const location = useLocation();

  useEffect(() => {
    setActualLocation(location.pathname);
  }, [location]);

  useEffect(() => {
    if (userRole === "1") {
      navigate("/homeAdmin");
    }
    else if (userRole !== "2" && userRole !== "3") {
      navigate("/");
    }
  }, [userRole, navigate]);

  return (
    <ResponsiveSideBar>
        <Outlet/>
    </ResponsiveSideBar>
  )
};

export default AlumnoRoutes;
